import { Badge, Button } from '@cloudflare/kumo';
import { useCallback, useEffect, useState } from 'react';
import { useAuthenticatedFetch } from '../../hooks/useAuthenticatedFetch';
import { useAppToast } from '../../hooks/useAppToast';
import { ICONS, Glyph } from '../../components/ui/icons';
import { PerfilHeader, quando, ha } from './ui';
import { SkeletonList } from '../../components/ui/Skeleton';

interface Sessao { id: string; userAgent: string | null; ip: string | null; createdAt: string; lastSeenAt: string; current: boolean }

function aparelho(ua: string | null) {
  const s = ua || '';
  const so = /Windows/.test(s) ? 'Windows' : /Android/.test(s) ? 'Android' : /iPhone|iPad|iOS/.test(s) ? 'iOS' : /Mac OS/.test(s) ? 'macOS' : /Linux/.test(s) ? 'Linux' : 'Desconhecido';
  const nav = /Edg\//.test(s) ? 'Edge' : /OPR\//.test(s) ? 'Opera' : /Chrome\//.test(s) ? 'Chrome' : /Firefox\//.test(s) ? 'Firefox' : /Safari\//.test(s) ? 'Safari' : 'Navegador';
  return { so, nav };
}

export function SessoesPage() {
  const fetchApi = useAuthenticatedFetch();
  const toast = useAppToast();
  const [rows, setRows] = useState<Sessao[] | null>(null);

  const load = useCallback(async () => {
    const r = await fetchApi('/api/account/sessions');
    if (r.ok) setRows((await r.json()).sessions);
  }, [fetchApi]);
  useEffect(() => { load(); }, [load]);

  const revogar = async (id: string) => {
    const r = await fetchApi(`/api/account/sessions/${id}`, { method: 'DELETE' });
    if (r.ok) { toast.success('Sessão encerrada'); load(); } else toast.error('Não foi possível encerrar');
  };
  const revogarOutras = async () => {
    const r = await fetchApi('/api/account/sessions/revoke-others', { method: 'POST' });
    if (r.ok) { toast.success('Outras sessões encerradas'); load(); } else toast.error('Não foi possível encerrar');
  };

  return (
    <>
      <PerfilHeader
        title="Sessões ativas"
        description="Aparelhos e sessões com acesso à sua conta."
        actions={rows && rows.length > 1 ? <Button variant="secondary-destructive" onClick={revogarOutras}>Encerrar as outras</Button> : undefined}
      />
      <div className="px-6 py-6 space-y-4">
        {!rows && <SkeletonList rows={3} label="Carregando sessões" />}
        {rows?.map((s) => {
          const a = aparelho(s.userAgent);
          return (
            <section key={s.id} className="overflow-hidden rounded-lg border border-kumo-line bg-kumo-base">
              <div className="flex items-center justify-between gap-3 border-b border-kumo-line bg-kumo-tint px-4 py-2">
                <div className="flex items-center gap-2 font-medium text-kumo-default"><Glyph icon={ICONS.Desktop} size={16} /> {a.so}</div>
                {s.current ? <Badge variant="primary">Sessão atual</Badge> : <Button size="sm" variant="secondary" onClick={() => revogar(s.id)}>Revogar</Button>}
              </div>
              <ul className="space-y-2 px-4 py-3 text-sm text-kumo-subtle">
                <li className="flex items-center gap-2"><Glyph icon={ICONS.GlobeAmericas} size={14} /> Navegador: {a.nav} · IP: {s.ip ?? '—'}</li>
                <li className="flex items-center gap-2"><Glyph icon={ICONS.Clock} size={14} /> Entrada: {quando(s.createdAt)} · Último acesso: {s.current ? 'agora há pouco' : ha(s.lastSeenAt)}</li>
              </ul>
            </section>
          );
        })}
        {rows?.length === 0 && <p className="text-sm text-kumo-subtle">Nenhuma sessão ativa.</p>}
      </div>
    </>
  );
}

export default SessoesPage;
